<!--suppress ALL -->
<div class="container-fluid justify-content-center mb-0 pt-1 pb-0 shadow-lg col-12">
  <div class="jumbotron-fluid mx-0 px-0 my-0 pt-1 pb-0">
    <div class="container mt-2 mb-0 mx-0 shadow-lg col-12">
      <div class="row">
        <div class="col-12">
          <h3 class="rub-head4 text-info text-center font-weight-bold py-1">
            Transaction Reports
          </h3>
        </div>
      </div>
    </div>
    <div class="search-container container mx-auto px-0 my-0 py-0 col-12">
      <div class="d-flex my-0 py-0 mx-auto px-auto">
        <div class="col-12 mx-0 px-3 px-sm-2 px-lg-3">
          <form [formGroup]="userForm">
            <div class="row">
              <div class="col-12 mx-0 px-0 px-sm-1 pt-1">
                <div class="row align-content-center">
                  <div class="col-6 col-md-4 col-lg-4">
                    <select
                      formControlName="report_type"
                      class="form-control"
                      autocomplete="off"
                      placeholder="Specify Type"
                      (change)="changeReport(userForm.controls.report_type.value)"
                    >
                      <option selected>Specify Type</option>
                      <option *ngFor="let report of reports; let i = index">
                        {{ report }}
                      </option>
                    </select>
                  </div>
                  <div class="col-6 col-md-4 col-lg-4 d-flex flex-row">
                    <div class="input-group mb-0">
                      <input
                        id="range_date"
                        formControlName="range_date"
                        type="text"
                        class="form-control"
                        placeholder="Select date range"
                        autocomplete="off"
                        bsDaterangepicker
                        [bsConfig]="{
                           containerClass: 'theme-blue',
                           dateInputFormat: 'MM/DD/YYYY',
                           isAnimated: true
                         }"
                        placement="bottom"
                      />
                    </div>
                  </div>
                  <div class="col-6 col-md-4 col-lg-4">
                    <app-search
                      [data]="getReportsCopy()"
                      [type]="type"
                      (searchResult)="searchResponse($event)"
                    ></app-search>
                  </div>
                  <div class="col-6 col-md-2 col-lg-2 mt-md-1 mt-lg-1">
                    <!-- spacer -->
                  </div>
                  <div class="col-6 col-md-3 col-lg-3 mt-md-1 mt-lg-1">
                    <!-- spacer -->
                  </div>
                  <div class="col-6 col-md-3 col-lg-3 my-auto">
                    <button
                      [disabled]="type !== 'Individuals Savings'"
                      (click)="selectFromData(dataModal, 100)"
                      class="btn btn-info col-8"
                      type="button"
                    >
                      Select Saving's Client
                    </button>
                  </div>
                  <div class="col-6 col-md-4 col-lg-4 d-flex flex-row my-auto">
                    <button
                      class="btn btn-info col-5"
                      type="button"
                      (click)="fetchReport(userForm.controls.range_date.value)"
                    > Get Report</button>
                    <app-export-btn [type]="type"></app-export-btn>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="row d-flex mt-1">
            <mat-paginator
              class="ml-md-auto"
              [length]="singleReport?.length"
              [pageSize]='pageSize'
              (page)="getPaginatorData($event)"
              [pageSizeOptions]="pageSizeOptions()"
              showFirstLastButtons="true"
            >
            </mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--card for displaying All Loans Report -->
<div
  *ngIf="type === 'All Loans' && singleReport"
  [id]="type"
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          All Loans Report
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class=""> Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          style="height: auto !important"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-2 col-xl-1 mx-0 px-2">
                <img
                  class="img-circle-1 mt-2 mt-md-0 mt-xl-1 mb-1 pb-0"
                  alt="none"
                  [src]="itm.customerPhotoUrl"
                  (click)="openModal(template, itm.customerPhotoUrl)"
                />
              </div>
              <div class="col-10 col-xl-11">
                <app-loan-report
                  [itm]="itm"
                  (loanActions)="loanActions($event)"
                  [showActions]="true"
                ></app-loan-report>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="totals-row row mb-3 mx-auto px-auto py-2 border-bottom"
      *ngIf="totals"
    >
      <div class="totals-field col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Paid:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestPaid === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestPaid | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-1 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Remaining:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestRemain === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestRemain | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-2 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Reversed:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestRemain === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestReversed | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-3 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Taken:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestTaken === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestTaken | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-4 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Written Off:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestWrittenOff === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestWrittenOff | number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--card for displaying All Loans Principal -->
<div
  *ngIf="type === 'All Loan Principal' && singleReport"
  [id]="type"
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          All Loans Principal
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class=""> Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-2 col-xl-1 mx-0 px-2">
                <img
                  class="img-circle-1 mt-2 mt-md-0 mt-xl-1 mb-1 pb-0"
                  [src]="itm.customerPhotoUrl"
                  (click)="openModal(template, itm.customerPhotoUrl)"
                />
              </div>
              <div class="col-10 col-xl-11">
                <app-loan-principal [itm]="itm"></app-loan-principal>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="totals-row row mb-3 mx-auto px-auto py-2 border-bottom"
      *ngIf="totals"
    >
      <div class="totals-field-a col-12 col-md-6 col-lg-4">
        <div class="row">
          <div class="col-6 col-xl-5 d-flex justify-content-start">
            <span class="font-weight-bold">Principal Amount:</span>
          </div>
          <div
            class="col-6 col-xl-7 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.principalAmount === null"
          >
            <span class="itemCreated">
              {{ totals.principalAmount | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-1-a col-12 col-md-6 col-lg-4">
        <div class="row">
          <div class="col-6 col-lg-5 d-flex justify-content-start">
            <span class="font-weight-bold">Principal Paid:</span>
          </div>
          <div
            class="col-6 col-lg-7 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.principalPaid === null"
          >
            <span class="itemCreated">
              {{ totals.principalPaid | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-2-a col-12 col-md-6 col-lg-4">
        <div class="row">
          <div class="col-6 col-lg-5 d-flex justify-content-start">
            <span class="font-weight-bold">Principal Left:</span>
          </div>
          <div
            class="col-6 col-lg-7 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.principalRemaining === null"
          >
            <span class="itemCreated">
              {{ totals.principalRemaining | number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--card for displaying cash ledger-->
<div
  [id]="type"
  *ngIf="
    type === 'Cash Ledger' &&
    userForm.controls.location.value !== '' &&
    userForm.controls.range_date.value !== '' &&
    singleReport
  "
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          Cash Ledger
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class="">Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-12">
                <app-ledger [itm]="itm"></app-ledger>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="totals-row row mb-3 mx-auto px-auto py-2 border-bottom"
      *ngIf="totals"
    >
      <div class="totals-field-a col-12 col-md-6 col-lg-4">
        <div class="row">
          <div class="col-5 d-flex justify-content-start">
            <span class="font-weight-bold">Total Cash In:</span>
          </div>
          <div
            class="col-7 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.cashInX1 === null"
          >
            <span class="itemCreated">
              {{ totals.cashInX1 | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-1-a col-12 col-md-6 col-lg-4">
        <div class="row">
          <div class="col-5 d-flex justify-content-start">
            <span class="font-weight-bold">Total Cash Out:</span>
          </div>
          <div
            class="col-7 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.cashOutX1 === null"
          >
            <span class="itemCreated">
              {{ totals.cashOutX1 | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-2-a col-12 col-md-6 col-lg-4">
        <div class="row">
          <div class="col-5 d-flex justify-content-start">
            <span class="font-weight-bold">Net Balance:</span>
          </div>
          <div class="col-7 d-flex justify-content-start font-weight-bold text-info">
            <span class="itemCreated">
              {{ totals.balanceX1 | number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--card for displaying paid ledger-->
<div
  [id]="type"
  *ngIf="
    type === 'Paid Ledger' &&
    singleReport &&
    userForm.controls.location.value !== '' &&
    userForm.controls.range_date.value !== ''
  "
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          Paid Ledger
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class="">Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <!--  -->
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-12">
                <app-ledger [itm]="itm"></app-ledger>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="totals-row row mb-3 mx-auto px-auto py-2 border-bottom"
      *ngIf="totals"
    >
      <div class="totals-field-a col-12 col-md-6 col-lg-4">
        <div class="row">
          <div class="col-5 d-flex justify-content-start">
            <span class="font-weight-bold">Total Cash In:</span>
          </div>
          <div
            class="col-7 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.cashInX1 === null"
          >
            <span class="itemCreated">
              {{ totals.cashInX1 | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-1-a col-12 col-md-6 col-lg-4">
        <div class="row">
          <div class="col-5 d-flex justify-content-start">
            <span class="font-weight-bold">Total Cash Out:</span>
          </div>
          <div
            class="col-7 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.cashOutX1 === null"
          >
            <span class="itemCreated">
              {{ totals.cashOutX1 | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-2-a col-12 col-md-6 col-lg-4">
        <div class="row">
          <div class="col-5 d-flex justify-content-start">
            <span class="font-weight-bold">Net Balance:</span>
          </div>
          <div class="col-7 d-flex justify-content-start font-weight-bold text-info">
            <span class="itemCreated">
              {{ totals.balanceX1 | number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--card for displaying Borrowed ledger-->
<div
  [id]="type"
  *ngIf="
    type === 'Borrowed Ledger' &&
    singleReport &&
    userForm.controls.location.value !== '' &&
    userForm.controls.range_date.value !== ''
  "
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          Borrowed Ledger
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class="">Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <!--  -->
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-12">
                <app-ledger [itm]="itm"></app-ledger>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="totals-row row mb-3 mx-auto px-auto py-2 border-bottom"
      *ngIf="totals"
    >
      <div class="totals-field-a col-12 col-md-6 col-lg-4">
        <div class="row">
          <div class="col-5 d-flex justify-content-start">
            <span class="font-weight-bold">Total Cash In:</span>
          </div>
          <div
            class="col-7 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.cashInX1 === null"
          >
            <span class="itemCreated">
              {{ totals.cashInX1 | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-1-a col-12 col-md-6 col-lg-4">
        <div class="row">
          <div class="col-5 d-flex justify-content-start">
            <span class="font-weight-bold">Total Cash Out:</span>
          </div>
          <div
            class="col-7 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.cashOutX1 === null"
          >
            <span class="itemCreated">
              {{ totals.cashOutX1 | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-2-a col-12 col-md-6 col-lg-4">
        <div class="row">
          <div class="col-5 d-flex justify-content-start">
            <span class="font-weight-bold">Net Balance:</span>
          </div>
          <div class="col-7 d-flex justify-content-start font-weight-bold text-info">
            <span class="itemCreated">
              {{ totals.balanceX1 | number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--card for displaying Float deposit ledger-->
<div
  *ngIf="type === 'Float Deposits' && singleReport"
  [id]="type"
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          Float Deposit Ledger
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class="">Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-12">
                <app-float [itm]="itm"></app-float>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="totals-row row mb-3 mx-auto px-auto py-2 border-bottom"
      *ngIf="totals"
    >
      <div class="totals-field-a col-12 col-md-6 col-lg-4">
        <div class="row">
          <div class="col-5 col-md-4 d-flex justify-content-start">
            <span class="font-weight-bold">Cash In:</span>
          </div>
          <div
            class="col-7 col-md-8 d-flex justify-content-start font-weight-bold text-info mx-md-0"
            [hidden]="totals.cashInX1 === null"
          >
            <span class="itemCreated">
              {{ totals.cashInX1 | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-1-a col-12 col-md-6 col-lg-4">
        <div class="row">
          <div class="col-5 col-md-4 d-flex justify-content-start">
            <span class="font-weight-bold">Cash Out:</span>
          </div>
          <div
            class="col-7 col-md-8 d-flex justify-content-start font-weight-bold text-info mx-md-0"
            [hidden]="totals.cashOutX1 === null"
          >
            <span class="itemCreated">
              {{ totals.cashOutX1 | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-2-a col-12 col-md-6 col-lg-4">
        <div class="row">
          <div class="col-5 col-md-4 d-flex justify-content-start">
            <span class="font-weight-bold">Balance:</span>
          </div>
          <div
            class="col-7 col-md-8 d-flex justify-content-start font-weight-bold text-info mx-md-0"
            [hidden]="totals.balanceX1 === null"
          >
            <span class="itemCreated">
              {{ totals.balanceX1 | number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--card for displaying float withdraw ledger-->
<div
  *ngIf="type === 'Float Withdraws' && singleReport"
  [id]="type"
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          Float Withdraw Ledger
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class="">Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-12">
                <app-float [itm]="itm"></app-float>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="totals-row row mb-3 mx-auto px-auto py-2 border-bottom"
      *ngIf="totals"
    >
      <div class="totals-field-a col-12 col-md-6 col-lg-4">
        <div class="row">
          <div class="col-5 col-md-4 d-flex justify-content-start">
            <span class="font-weight-bold">Cash In:</span>
          </div>
          <div
            class="col-7 col-md-8 d-flex justify-content-start font-weight-bold text-info mx-md-0"
            [hidden]="totals.cashInX1 === null"
          >
            <span class="itemCreated">
              {{ totals.cashInX1 | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-1-a col-12 col-md-6 col-lg-4">
        <div class="row">
          <div class="col-5 col-md-4 d-flex justify-content-start">
            <span class="font-weight-bold">Cash Out:</span>
          </div>
          <div
            class="col-7 col-md-8 d-flex justify-content-start font-weight-bold text-info mx-md-0"
            [hidden]="totals.cashOutX1 === null"
          >
            <span class="itemCreated">
              {{ totals.cashOutX1 | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-2-a col-12 col-md-6 col-lg-4">
        <div class="row">
          <div class="col-5 col-md-4 d-flex justify-content-start">
            <span class="font-weight-bold">Balance:</span>
          </div>
          <div
            class="col-7 col-md-8 d-flex justify-content-start font-weight-bold text-info mx-md-0"
            [hidden]="totals.balanceX1 === null"
          >
            <span class="itemCreated">
              {{ totals.balanceX1 | number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--card for displaying float deposit and withdraw ledger-->
<div
  *ngIf="type === 'Float Deposit & Withdraw' && singleReport"
  [id]="type"
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          Float Withdraw & Deposit Ledger
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class="">Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-12">
                <app-float [itm]="itm"></app-float>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="totals-row row mb-3 mx-auto px-auto py-2 border-bottom"
      *ngIf="totals"
    >
      <div class="totals-field-a col-12 col-md-6 col-lg-4">
        <div class="row">
          <div class="col-5 col-md-4 d-flex justify-content-start">
            <span class="font-weight-bold">Cash In:</span>
          </div>
          <div
            class="col-7 col-md-8 d-flex justify-content-start font-weight-bold text-info mx-md-0"
            [hidden]="totals.cashInX1 === null"
          >
            <span class="itemCreated">
              {{ totals.cashInX1 | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-1-a col-12 col-md-6 col-lg-4">
        <div class="row">
          <div class="col-5 col-md-4 d-flex justify-content-start">
            <span class="font-weight-bold">Cash Out:</span>
          </div>
          <div
            class="col-7 col-md-8 d-flex justify-content-start font-weight-bold text-info mx-md-0"
            [hidden]="totals.cashOutX1 === null"
          >
            <span class="itemCreated">
              {{ totals.cashOutX1 | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-2-a col-12 col-md-6 col-lg-4">
        <div class="row">
          <div class="col-5 col-md-4 d-flex justify-content-start">
            <span class="font-weight-bold">Balance:</span>
          </div>
          <div
            class="col-7 col-md-8 d-flex justify-content-start font-weight-bold text-info mx-md-0"
            [hidden]="totals.balanceX1 === null"
          >
            <span class="itemCreated">
              {{ totals.balanceX1 | number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--card for displaying Float Balance Per Day report-->
<div
  *ngIf="type === 'Float Balance Per Day' && singleReport"
  [id]="type"
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          Float Balance Per Day
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class="">Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-12">
                <app-float-per-day [itm]="itm"></app-float-per-day>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--card for displaying individual savings report-->
<div
  *ngIf="type === 'Individuals Savings' && singleReport"
  [id]="type"
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          Individual Savings Report
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class="">Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-2 col-xl-1 mx-0 px-2">
                <img
                  class="img-circle-1 mt-2 mt-md-0 mt-xl-1 mb-1 pb-0"
                  [src]="itm.customerPhotoUrl"
                  (click)="openModal(template, itm.customerPhotoUrl)"
                />
              </div>
              <div class="col-10 col-xl-11">
                <app-savings [itm]="itm"></app-savings>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="totals-row row mb-3 mx-auto px-auto py-2 border-bottom"
      *ngIf="totals"
    >
      <div class="totals-field-a col-12 col-md-6 col-lg-4">
        <div class="row">
          <div class="col-6 col-lg-5 d-flex justify-content-start">
            <span class="font-weight-bold">Savings Added:</span>
          </div>
          <div
            class="col-6 col-lg-7 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.savingsAdded === null"
          >
            <span class="itemCreated">
              {{ totals.savingsAdded | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-1-a col-12 col-md-6 col-lg-4">
        <div class="row">
          <div class="col-6 col-xl-5 d-flex justify-content-start">
            <span class="font-weight-bold">Savings Removed:</span>
          </div>
          <div
            class="col-6 col-xl-7 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.savingsRemoved === null"
          >
            <span class="itemCreated">
              {{ totals.savingsRemoved | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-2-a col-12 col-md-6 col-lg-4">
        <div class="row">
          <div class="col-6 col-lg-5 d-flex justify-content-start">
            <span class="font-weight-bold">Savings Balance:</span>
          </div>
          <div
            class="col-6 col-lg-7 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.savingsBalance === null"
          >
            <span class="itemCreated">
              {{ totals.savingsBalance | number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--card for displaying general savings report-->
<div
  *ngIf="type === 'General Savings Balances' && singleReport"
  [id]="type"
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          General Savings Balances Report
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class="">Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-2 col-xl-1 mx-0 px-2">
                <img
                  class="img-circle-1 mt-2 mt-md-0 mt-xl-1 mb-1 pb-0"
                  [src]="itm.customerPhotoUrl"
                  (click)="openModal(template, itm.customerPhotoUrl)"
                />
              </div>
              <div class="col-10 col-xl-11">
                <app-savings [itm]="itm"></app-savings>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="totals-row row mb-3 mx-auto px-auto py-2 border-bottom"
      *ngIf="totals"
    >
      <div class="totals-field-a col-12 col-md-6 col-lg-4">
        <div class="row">
          <div class="col-6 col-lg-5 d-flex justify-content-start">
            <span class="font-weight-bold">Savings Added:</span>
          </div>
          <div
            class="col-6 col-lg-7 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.savingsAdded === null"
          >
            <span class="itemCreated">
              {{ totals.savingsAdded | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-1-a col-12 col-md-6 col-lg-4">
        <div class="row">
          <div class="col-6 col-xl-5 d-flex justify-content-start">
            <span class="font-weight-bold">Savings Removed:</span>
          </div>
          <div
            class="col-6 col-xl-7 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.savingsRemoved === null"
          >
            <span class="itemCreated">
              {{ totals.savingsRemoved | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-2-a col-12 col-md-6 col-lg-4">
        <div class="row">
          <div class="col-6 col-lg-5 d-flex justify-content-start">
            <span class="font-weight-bold">Savings Balance:</span>
          </div>
          <div
            class="col-6 col-lg-7 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.savingsBalance === null"
          >
            <span class="itemCreated">
              {{ totals.savingsBalance | number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--General savings report-->
<div
  *ngIf="type === 'General Savings' && singleReport"
  [id]="type"
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          General Savings Report
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class="">Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-2 col-xl-1 mx-0 px-2">
                <img
                  class="img-circle-1 mt-2 mt-xl-1 mb-1 pb-0"
                  [src]="itm.customerPhotoUrl"
                  (click)="openModal(template, itm.customerPhotoUrl)"
                />
              </div>
              <div class="col-10 col-xl-11">
                <app-savings [itm]="itm"></app-savings>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="totals-row row mb-3 mx-auto px-auto py-2 border-bottom"
      *ngIf="totals"
    >
      <div class="totals-field-a col-12 col-md-6 col-lg-4">
        <div class="row">
          <div class="col-6 col-lg-5 d-flex justify-content-start">
            <span class="font-weight-bold">Savings Added:</span>
          </div>
          <div
            class="col-6 col-lg-7 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.savingsAdded === null"
          >
            <span class="itemCreated">
              {{ totals.savingsAdded | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-1-a col-12 col-md-6 col-lg-4">
        <div class="row">
          <div class="col-6 col-xl-5 d-flex justify-content-start">
            <span class="font-weight-bold">Savings Removed:</span>
          </div>
          <div
            class="col-6 col-xl-7 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.savingsRemoved === null"
          >
            <span class="itemCreated">
              {{ totals.savingsRemoved | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-2-a col-12 col-md-6 col-lg-4">
        <div class="row">
          <div class="col-6 col-lg-5 d-flex justify-content-start">
            <span class="font-weight-bold">Savings Balance:</span>
          </div>
          <div
            class="col-6 col-lg-7 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.savingsBalance === null"
          >
            <span class="itemCreated">
              {{ totals.savingsBalance | number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--card for displaying revenue report-->
<div
  *ngIf="type === 'Revenue Ledger' && singleReport"
  [id]="type"
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          Revenue Ledger
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class="">Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-12">
                <app-revenue-ledger [itm]="itm"></app-revenue-ledger>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="totals-row row mb-3 mx-auto px-auto py-2 border-bottom"
      *ngIf="totals"
    >
      <div class="col-12 col-md-6">
        <div class="row">
          <div class="col-6 d-flex justify-content-start">
            <span class="font-weight-bold">Total Interest Earned: </span>
          </div>
          <div class="col-6 d-flex justify-content-start font-weight-bold text-info">
            <span class="itemCreated">
              {{ totals.revenueEarned | number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--card for displaying lost revenue report-->
<div
  *ngIf="type === 'Lost Revenue' && singleReport"
  [id]="type"
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          Lost Revenue Report
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class="">Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-12">
                <app-revenue-ledger [itm]="itm"></app-revenue-ledger>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="totals-row row mb-3 mx-auto px-auto py-2 border-bottom">
      <div class="col-12 col-md-6">
        <div class="row">
          <div class="col-6 d-flex justify-content-start">
            <span class="font-weight-bold">Total Revenue Lost: </span>
          </div>
          <div class="col-6 d-flex justify-content-start font-weight-bold text-info">
            <span class="itemCreated">
              {{ totals.revenueLost | number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--card for displaying Defaulters Report-->
<div
  *ngIf="type === 'Bodaboda Defaulters' && singleReport"
  [id]="type"
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          Bodaboda Defaulters Report
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class="">Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <!--  -->
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-2 col-xl-1 mx-0 px-2">
                <img
                  class="img-circle-1 mt-2 mt-xl-1 mb-1 pb-0"
                  [src]="itm.customerPhotoUrl"
                  (click)="openModal(template, itm.customerPhotoUrl)"
                />
              </div>
              <div class="col-10 col-xl-11">
                <app-loan-report [itm]="itm"></app-loan-report>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="totals-row row mb-3 mx-auto px-auto py-2 border-bottom"
      *ngIf="totals"
    >
      <div class="totals-field col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Paid:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestPaid === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestPaid | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-1 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Remaining:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestRemain === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestRemain | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-2 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Reversed:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestRemain === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestReversed | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-3 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Taken:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestTaken === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestTaken | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-4 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Written Off:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestWrittenOff === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestWrittenOff | number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--card for displaying Taxi Defaulters Report-->
<div
  *ngIf="type === 'Taxi Defaulters' && singleReport"
  [id]="type"
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          Taxi Defaulters Report
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class="">Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <!--  -->
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-2 col-xl-1 mx-0 px-2">
                <img
                  class="img-circle-1 mt-2 mt-xl-1 mb-1 pb-0"
                  [src]="itm.customerPhotoUrl"
                  (click)="openModal(template, itm.customerPhotoUrl)"
                />
              </div>
              <div class="col-10 col-xl-11">
                <app-loan-report [itm]="itm"></app-loan-report>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="totals-row row mb-3 mx-auto px-auto py-2 border-bottom"
      *ngIf="totals"
    >
      <div class="totals-field col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Paid:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestPaid === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestPaid | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-1 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Remaining:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestRemain === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestRemain | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-2 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Reversed:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestRemain === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestReversed | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-3 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Taken:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestTaken === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestTaken | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-4 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Written Off:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestWrittenOff === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestWrittenOff | number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="type === 'Micro Defaulters' && singleReport"
  [id]="type"
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          Micro Defaulters Report
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class="">Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <!--  -->
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-2 col-xl-1 mx-0 px-2">
                <img
                  class="img-circle-1 mt-2 mt-xl-1 mb-1 pb-0"
                  [src]="itm.customerPhotoUrl"
                  (click)="openModal(template, itm.customerPhotoUrl)"
                />
              </div>
              <div class="col-10 col-xl-11">
                <app-loan-report
                  [itm]="itm"
                  (loanActions)="loanActions($event)"
                  [showActions]="true"
                ></app-loan-report>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="totals-row row mb-3 mx-auto px-auto py-2 border-bottom"
      *ngIf="totals"
    >
      <div class="totals-field col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Paid:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestPaid === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestPaid | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-1 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Remaining:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestRemain === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestRemain | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-2 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Reversed:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestRemain === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestReversed | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-3 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Taken:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestTaken === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestTaken | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-4 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Written Off:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestWrittenOff === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestWrittenOff | number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--card for displaying Recovery Report-->
<div
  *ngIf="type === 'Bodaboda Recovery' && singleReport"
  [id]="type"
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          Bodaboda Recovery Report
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class=""> Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-2 col-xl-1 mx-0 px-2">
                <img
                  class="img-circle-1 mt-2 mt-xl-1 mb-1 pb-0"
                  [src]="itm.customerPhotoUrl"
                  (click)="openModal(template, itm.customerPhotoUrl)"
                />
              </div>
              <div class="col-10 col-xl-11">
                <app-loan-report [itm]="itm"></app-loan-report>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="totals-row row mb-3 mx-auto px-auto py-2 border-bottom"
      *ngIf="totals"
    >
      <div class="totals-field col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Paid:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestPaid === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestPaid | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-1 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Remaining:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestRemain === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestRemain | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-2 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Reversed:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestRemain === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestReversed | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-3 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Taken:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestTaken === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestTaken | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-4 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Written Off:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestWrittenOff === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestWrittenOff | number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="type === 'Taxi Recovery' && singleReport"
  [id]="type"
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          Taxi Recovery Report
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class=""> Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-2 col-xl-1 mx-0 px-2">
                <img
                  class="img-circle-1 mt-2 mt-xl-1 mb-1 pb-0"
                  [src]="itm.customerPhotoUrl"
                  (click)="openModal(template, itm.customerPhotoUrl)"
                />
              </div>
              <div class="col-10 col-xl-11">
                <app-loan-report [itm]="itm"></app-loan-report>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="totals-row row mb-3 mx-auto px-auto py-2 border-bottom"
      *ngIf="totals"
    >
      <div class="totals-field col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Paid:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestPaid === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestPaid | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-1 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Remaining:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestRemain === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestRemain | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-2 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Reversed:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestRemain === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestReversed | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-3 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Taken:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestTaken === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestTaken | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-4 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Written Off:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestWrittenOff === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestWrittenOff | number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="type === 'Micro Recovery' && singleReport"
  [id]="type"
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          Micro Recovery Report
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class=""> Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-2 col-xl-1 mx-0 px-2">
                <img
                  class="img-circle-1 mt-2 mt-xl-1 mb-1 pb-0"
                  [src]="itm.customerPhotoUrl"
                  (click)="openModal(template, itm.customerPhotoUrl)"
                />
              </div>
              <div class="col-10 col-xl-11">
                <app-loan-report [itm]="itm"></app-loan-report>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="totals-row row mb-3 mx-auto px-auto py-2 border-bottom"
      *ngIf="totals"
    >
      <div class="totals-field col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Paid:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestPaid === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestPaid | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-1 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Remaining:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestRemain === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestRemain | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-2 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Reversed:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestRemain === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestReversed | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-3 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Taken:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestTaken === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestTaken | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-4 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Written Off:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestWrittenOff === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestWrittenOff | number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--card for displaying Bodaboda Enforcement Report-->
<div
  *ngIf="type === 'Bodaboda Enforcement' && singleReport"
  [id]="type"
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          Bodaboda Enforcement Report
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class=""> Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-2 col-xl-1 mx-0 px-2">
                <img
                  class="img-circle-1 mt-2 mt-xl-1 mb-1 pb-0"
                  [src]="itm.customerPhotoUrl"
                  (click)="openModal(template, itm.customerPhotoUrl)"
                />
              </div>
              <div class="col-10 col-xl-11">
                <app-loan-report [itm]="itm"></app-loan-report>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="totals-row row mb-3 mx-auto px-auto py-2 border-bottom"
      *ngIf="totals"
    >
      <div class="totals-field col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Paid:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestPaid === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestPaid | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-1 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Remaining:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestRemain === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestRemain | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-2 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Reversed:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestRemain === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestReversed | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-3 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Taken:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestTaken === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestTaken | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-4 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Written Off:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestWrittenOff === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestWrittenOff | number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="type === 'Taxi Enforcement' && singleReport"
  [id]="type"
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          Taxi Enforcement Report
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class=""> Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-2 col-xl-1 mx-0 px-2">
                <img
                  class="img-circle-1 mt-2 mt-xl-1 mb-1 pb-0"
                  [src]="itm.customerPhotoUrl"
                  (click)="openModal(template, itm.customerPhotoUrl)"
                />
              </div>
              <div class="col-10 col-xl-11">
                <app-loan-report [itm]="itm"></app-loan-report>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="totals-row row mb-3 mx-auto px-auto py-2 border-bottom"
      *ngIf="totals"
    >
      <div class="totals-field col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Paid:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestPaid === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestPaid | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-1 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Remaining:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestRemain === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestRemain | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-2 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Reversed:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestRemain === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestReversed | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-3 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Taken:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestTaken === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestTaken | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-4 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Written Off:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestWrittenOff === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestWrittenOff | number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="type === 'Micro Enforcement' && singleReport"
  [id]="type"
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          Micro Enforcement Report
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class=""> Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-2 col-xl-1 mx-0 px-2">
                <img
                  class="img-circle-1 mt-2 mt-xl-1 mb-1 pb-0"
                  [src]="itm.customerPhotoUrl"
                  (click)="openModal(template, itm.customerPhotoUrl)"
                />
              </div>
              <div class="col-10 col-xl-11">
                <app-loan-report [itm]="itm"></app-loan-report>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="totals-row row mb-3 mx-auto px-auto py-2 border-bottom"
      *ngIf="totals"
    >
      <div class="totals-field col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Paid:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestPaid === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestPaid | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-1 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Remaining:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestRemain === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestRemain | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-2 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Reversed:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestRemain === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestReversed | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-3 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Taken:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestTaken === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestTaken | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-4 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Written Off:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestWrittenOff === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestWrittenOff | number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--card for displaying Reverse Principal Report-->
<div
  *ngIf="type === 'Reversed Principal' && singleReport"
  [id]="type"
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          Reversed Principal Report
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class="">Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-12">
                <app-reversed-principal [itm]="itm"></app-reversed-principal>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="totals-row row mb-3 mx-auto px-auto py-2 border-bottom">
      <div class="col-12 col-md-6">
        <div class="row">
          <div class="col-6 d-flex justify-content-start">
            <span class="font-weight-bold">Principal Reversed:</span>
          </div>
          <div class="col-6 d-flex justify-content-start font-weight-bold text-info">
            <span class="itemCreated">
              {{ totals.princimpalReversed | number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--card for displaying commission report-->
<div
  [id]="type"
  *ngIf="
    type === 'Commission' &&
    singleReport &&
    userForm.controls.range_date.value !== ''
  "
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          Commission Report
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class="">Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-12">
                <app-commission [itm]="itm"></app-commission>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="totals-row row mb-3 mx-auto px-auto py-2 border-bottom"
      *ngIf="totals"
    >
      <div class="totals-field col-12 col-md-6">
        <div class="row">
          <div class="col-6 col-xl-5 d-flex justify-content-start">
            <span class="font-weight-bold">Commission Earned:</span>
          </div>
          <div
            class="col-6 col-xl-7 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.commissionEarned === null"
          >
            <span class="itemCreated">
              {{ totals.commissionEarned | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="row">
          <div class="col-6 col-xl-5 d-flex justify-content-start">
            <span class="font-weight-bold">Loan Interest Paid:</span>
          </div>
          <div class="col-6 col-xl-7 d-flex justify-content-start font-weight-bold text-info">
            <span class="itemCreated">
              {{ totals.loanInterestPaid | number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--card for displaying Interest Report-->
<div
  *ngIf="type === 'Interest' && singleReport"
  [id]="type"
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          Interest Report
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class="">Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-2 col-xl-1 mx-0 px-2">
                <img
                  class="img-circle-1 mt-2 mt-xl-1 mb-1 pb-0"
                  [src]="itm.customerPhotoUrl"
                  (click)="openModal(template, itm.customerPhotoUrl)"
                />
              </div>
              <div class="col-10 col-xl-11">
                <app-loan-interest [itm]="itm"></app-loan-interest>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="totals-row row mb-3 mx-auto px-auto py-2 border-bottom"
      *ngIf="totals"
    >
      <div class="totals-field-a col-12 col-md-6 col-lg-4">
        <div class="row">
          <div class="col-6 col-lg-5 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Taken:</span>
          </div>
          <div
            class="col-6 col-lg-7 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.InterestExpected === null"
          >
            <span class="itemCreated">
              {{ totals.InterestExpected | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-1-a col-12 col-md-6 col-lg-4">
        <div class="row">
          <div class="col-6 col-lg-5 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Paid:</span>
          </div>
          <div
            class="col-6 col-lg-7 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.InterestPaid === null"
          >
            <span class="itemCreated">
              {{ totals.InterestPaid | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-2-a col-12 col-md-6 col-lg-4">
        <div class="row">
          <div class="col-6 col-xl-5 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Remaining:</span>
          </div>
          <div class="col-6 col-xl-7 d-flex justify-content-start font-weight-bold text-info">
            <span class="itemCreated">
              {{ totals.InterestRemain | number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--card for displaying Micro Loan Security Report-->
<div
  *ngIf="type === 'Micro Loan Security' && singleReport"
  [id]="type"
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          Micro Loan Security
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class="">Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-2 col-xl-1 mx-0 px-2">
                <label class="pic-font">Client's Photo</label>
                <img
                  class="img-circle mt-2 mt-xl-1 mb-1 pb-0"
                  [src]="itm.customerPhotoUrl"
                  (click)="openModal(template, itm.customerPhotoUrl)"
                />
                <label class="pic-font">Security Photo</label>
                <img
                  class="img-circle mt-2 mt-md-0 mt-xl-1 mb-1 pb-0"
                  [src]="itm.securityPhotoUrl"
                  (click)="openModal(template, itm.securityPhotoUrl)"
                />
              </div>
              <div class="col-10 col-xl-11">
                <app-loan-security [itm]="itm"></app-loan-security>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="totals-row row mx-auto px-auto py-2 border-bottom"
      *ngIf="totals"
    >
      <div class="col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 d-flex justify-content-start">
            <span class="font-weight-bold">Loan Amount Taken:</span>
          </div>
          <div
            class="col-6 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.loanAmountTaken === null"
          >
            <span class="itemCreated">
              {{ totals.loanAmountTaken | number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--card for displaying Individual Micro Loan Security Report-->
<div
  *ngIf="type === 'Individual Micro Loan Security' && singleReport"
  [id]="type"
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          Individual Micro Loan Security
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class="">Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-2 col-xl-1 mx-0 px-2">
                <label class="pic-font">Client's Photo</label>
                <img
                  class="img-circle mt-2 mt-xl-1 mb-1 pb-0"
                  [src]="itm.customerPhotoUrl"
                  (click)="openModal(template, itm.customerPhotoUrl)"
                />
                <label class="pic-font">Security Photo</label>
                <img
                  class="img-circle mt-2 mt-md-0 mt-xl-1 mb-1 pb-0"
                  [src]="itm.securityPhotoUrl"
                  (click)="openModal(template, itm.securityPhotoUrl)"
                />
              </div>
              <div class="col-10 col-xl-11">
                <app-loan-security [itm]="itm"></app-loan-security>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="totals-row row mb-3 mx-auto px-auto py-2 border-bottom"
      *ngIf="totals"
    >
      <div class="col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 d-flex justify-content-start">
            <span class="font-weight-bold">Loan Amount Taken:</span>
          </div>
          <div
            class="col-6 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.loanAmountTaken === null"
          >
            <span class="itemCreated">
              {{ totals.loanAmountTaken | number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--card for displaying Taxi Loan Report-->
<div
  *ngIf="type === 'Taxi Loan' && singleReport"
  [id]="type"
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          Taxi Loan Report
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class=""> Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-2 col-xl-1 mx-0 px-2">
                <img
                  class="img-circle-1 mt-2 mt-xl-1 mb-1 pb-0"
                  [src]="itm.customerPhotoUrl"
                  (click)="openModal(template, itm.customerPhotoUrl)"
                />
              </div>
              <div class="col-10 col-xl-11">
                <app-loan-report [itm]="itm"></app-loan-report>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="totals-row row mb-3 mx-auto px-auto py-2 border-bottom"
      *ngIf="totals"
    >
      <div class="totals-field col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Paid:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestPaid === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestPaid | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-1 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Remaining:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestRemain === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestRemain | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-2 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Reversed:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestRemain === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestReversed | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-3 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Taken:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestTaken === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestTaken | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-4 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Written Off:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestWrittenOff === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestWrittenOff | number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--card for displaying Micro Loan Report-->
<div
  *ngIf="type === 'Micro Loan' && singleReport"
  [id]="type"
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          Micro Loan Report
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class=""> Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-2 col-xl-1 mx-0 px-2">
                <img
                  class="img-circle-1 mt-2 mt-xl-1 mb-1 pb-0"
                  [src]="itm.customerPhotoUrl"
                  (click)="openModal(template, itm.customerPhotoUrl)"
                />
              </div>
              <div class="col-10 col-xl-11">
                <app-loan-report
                  [itm]="itm"
                  (loanActions)="loanActions($event)"
                ></app-loan-report>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="totals-row row mb-3 mx-auto px-auto py-2 border-bottom"
      *ngIf="totals"
    >
      <div class="totals-field col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Paid:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestPaid === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestPaid | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-1 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Remaining:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestRemain === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestRemain | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-2 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Reversed:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestRemain === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestReversed | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-3 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Taken:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestTaken === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestTaken | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-4 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Written Off:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestWrittenOff === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestWrittenOff | number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--card for displaying Bodaboda Loan Report-->
<div
  *ngIf="type === 'Bodaboda Loan' && singleReport"
  [id]="type"
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          Bodaboda Loan Report
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class=""> Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-2 col-xl-1 mx-0 px-2">
                <img
                  class="img-circle-1 mt-2 mt-xl-1 mb-1 pb-0"
                  [src]="itm.customerPhotoUrl"
                  (click)="openModal(template, itm.customerPhotoUrl)"
                />
              </div>
              <div class="col-10 col-xl-11">
                <app-loan-report [itm]="itm"></app-loan-report>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="totals-row row mb-3 mx-auto px-auto py-2 border-bottom"
      *ngIf="totals"
    >
      <div class="totals-field col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Paid:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestPaid === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestPaid | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-1 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Remaining:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestRemain === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestRemain | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-2 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Reversed:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestRemain === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestReversed | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-3 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Taken:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestTaken === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestTaken | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-4 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Written Off:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestWrittenOff === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestWrittenOff | number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--card for displaying Micro-loan guarantor Report-->
<div
  *ngIf="type === 'Micro Loan Guarantor' && singleReport"
  [id]="type"
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          Micro Loan Guarantor Report
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class=""> Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-2 col-xl-1 mx-0 px-2">
                <label class="pic-font">Client</label>
                <img
                  class="img-circle mt-2 mt-xl-1 mb-1 pb-0"
                  [src]="itm.customerPhotoUrl"
                  (click)="openModal(template, itm.customerPhotoUrl)"
                />
                <label class="pic-font">Guarantor</label>
                <img
                  class="img-circle mt-2 mt-xl-1 mb-1 pb-0"
                  [src]="itm.gaurantorPhotoUrl"
                  (click)="openModal(template, itm.gaurantorPhotoUrl)"
                  alt="none"
                />
              </div>
              <div class="col-10 col-xl-11">
                <app-loan-gurantor [itm]="itm"></app-loan-gurantor>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="totals-row row mb-3 mx-auto px-auto py-2 border-bottom"
      *ngIf="totals"
    >
      <div class="col-12 col-md-6">
        <div class="row">
          <div class="col-6 d-flex justify-content-start">
            <span class="font-weight-bold">Loan Amount Taken:</span>
          </div>
          <div
            class="col-6 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.loanAmountTaken === null"
          >
            <span class="itemCreated">
              {{ totals.loanAmountTaken | number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="type === 'Individual Loan Guarantor' && singleReport"
  [id]="type"
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          Individual Loan Guarantor Report
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class="">Area: </span>
      </div>
      <div class="col-3 d-flex justify-content-start">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-2 col-xl-1 mx-0 px-2">
                <label class="pic-font">Client</label>
                <img
                  class="img-circle mt-2 mt-xl-1 mb-1 pb-0"
                  [src]="itm.customerPhotoUrl"
                  (click)="openModal(template, itm.customerPhotoUrl)"
                />
                <label class="pic-font">Guarantor</label>
                <img
                  class="img-circle mt-2 mt-xl-1 mb-1 pb-0"
                  [src]="itm.gaurantorPhotoUrl"
                  (click)="openModal(template, itm.gaurantorPhotoUrl)"
                  alt="none"
                />
              </div>
              <div class="col-10 col-xl-11">
                <app-loan-gurantor [itm]="itm"></app-loan-gurantor>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="totals-row row mb-3 mx-auto px-auto py-2 border-bottom"
      *ngIf="totals"
    >
      <div class="col-12 col-md-6">
        <div class="row">
          <div class="col-5 d-flex justify-content-start">
            <span class="font-weight-bold">Loan Amount Taken:</span>
          </div>
          <div
            class="col-7 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.loanAmountTaken === null"
          >
            <span class="itemCreated">
              {{ totals.loanAmountTaken | number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--card for displaying Micro-loan Amortization schedule-->
<div
  *ngIf="type === 'Micro Loan Amortization' && singleReport"
  [id]="type"
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          MicroLoan Amortization Schedule
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class=""> Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-2 col-xl-1 mx-0 px-2">
                <img
                  class="img-circle-1 mt-2 mt-xl-1 mb-1 pb-0"
                  [src]="microLoanProp.customer.customerPhotoUrl"
                  (click)="
                    openModal(template, microLoanProp.customer.customerPhotoUrl)
                  "
                />
              </div>
              <div class="col-10 col-xl-11">
                <app-amortization-schedule
                  [itm]="itm"
                  [customer]="microLoanProp.customer"
                ></app-amortization-schedule>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="totals-row row mb-3 mx-auto px-auto py-2 border-bottom"
      *ngIf="totals !== {}"
    >
      <div
        class="totals-field col-12 col-md-6 col-xl-4"
        *ngIf="totals.instalmentAmountX1 !== null"
      >
        <div class="row">
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="">Instalment Amount:</span>
          </div>
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="itemCreated">
              {{ totals.instalmentAmountX1 | number }}
            </span>
          </div>
        </div>
      </div>
      <div
        class="totals-field-1 col-12 col-md-6 col-xl-4"
        *ngIf="totals.instalmentNumberX1 !== null"
      >
        <div class="row">
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="">Instalment Number:</span>
          </div>
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="itemCreated">
              {{ totals.instalmentNumberX1 }}
            </span>
          </div>
        </div>
      </div>
      <div
        class="totals-field-2 col-12 col-md-6 col-xl-4"
        *ngIf="totals.instalmentPaidX1 !== null"
      >
        <div class="row">
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="">Instalment Paid:</span>
          </div>
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="itemCreated">
              {{ totals.instalmentPaidX1 | number }}
            </span>
          </div>
        </div>
      </div>
      <div
        class="totals-field-3 col-12 col-md-6 col-xl-4"
        *ngIf="totals.instalmentPaymentDateX1 !== null"
      >
        <div class="row">
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="">Payment Date:</span>
          </div>
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="itemCreated">
              {{ totals.instalmentPaymentDateX1 }}
            </span>
          </div>
        </div>
      </div>
      <div
        class="totals-field-4 col-12 col-md-6 col-xl-4"
        *ngIf="totals.instalmentPaymentTimeX1 !== null"
      >
        <div class="row">
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="">Payment Time:</span>
          </div>
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="itemCreated">
              {{ totals.instalmentPaymentTimeX1 }}
            </span>
          </div>
        </div>
      </div>
      <div
        class="col-12 col-md-6 col-xl-4"
        *ngIf="totals.instalmentRemainingX1 !== null"
      >
        <div class="row">
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="">Instalment Remaining:</span>
          </div>
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="itemCreated">
              {{ totals.instalmentRemainingX1 | number}}
            </span>
          </div>
        </div>
      </div>
      <div
        class="totals-field col-12 col-md-6 col-xl-4"
        *ngIf="totals.instalmentStatusX1 !== null"
      >
        <div class="row">
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="">Instalment Status:</span>
          </div>
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="itemCreated">
              {{ totals.instalmentStatusX1 }}
            </span>
          </div>
        </div>
      </div>
      <div
        class="totals-field-1 ol-12 col-md-6 col-xl-4"
        *ngIf="totals.interestAmountX1 !== null"
      >
        <div class="row">
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="">Interest Amount:</span>
          </div>
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="itemCreated">
              {{ totals.interestAmountX1 | number }}
            </span>
          </div>
        </div>
      </div>
      <div
        class="totals-field-2 col-12 col-md-6 col-xl-4"
        *ngIf="totals.interestPaidX1 !== null"
      >
        <div class="row">
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="">Interest Paid:</span>
          </div>
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="itemCreated">
              {{ totals.interestPaidX1 | number }}
            </span>
          </div>
        </div>
      </div>
      <div
        class="totals-field-3 col-12 col-md-6 col-xl-4"
        *ngIf="totals.interestRemainingX1 !== null"
      >
        <div class="row">
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="">Interest Remaining:</span>
          </div>
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="itemCreated">
              {{ totals.interestRemainingX1 | number }}
            </span>
          </div>
        </div>
      </div>
      <div
        class="totals-field-4 col-12 col-md-6 col-xl-4"
        *ngIf="totals.interestReversedX1 !== null"
      >
        <div class="row">
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="">Interest Reversed:</span>
          </div>
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="itemCreated">
              {{ totals.interestReversedX1 | number }}
            </span>
          </div>
        </div>
      </div>
      <div
        class="col-12 col-md-6 col-xl-4"
        *ngIf="totals.interestWrittenOffX1 !== null"
      >
        <div class="row">
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="">Interest Written Off:</span>
          </div>
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="itemCreated">
              {{ totals.interestWrittenOffX1 | number }}
            </span>
          </div>
        </div>
      </div>
      <div
        class="totals-field col-12 col-md-6 col-xl-4"
        *ngIf="totals.penaltyAmountX1 !== null"
      >
        <div class="row">
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="">Penalty Amount:</span>
          </div>
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="itemCreated">
              {{ totals.penaltyAmountX1 | number }}
            </span>
          </div>
        </div>
      </div>
      <div
        class="totals-field-1 col-12 col-md-6 col-xl-4"
        *ngIf="totals.penaltyPaidX1 !== null"
      >
        <div class="row">
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="">Penalty Paid:</span>
          </div>
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="itemCreated">
              {{ totals.penaltyPaidX1 | number }}
            </span>
          </div>
        </div>
      </div>
      <div
        class="totals-field-2 col-12 col-md-6 col-xl-4"
        *ngIf="totals.penaltyRemainingX1 !== null"
      >
        <div class="row">
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="">Penalty Remaining:</span>
          </div>
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="itemCreated">
              {{ totals.penaltyRemainingX1 | number }}
            </span>
          </div>
        </div>
      </div>
      <div
        class="totals-field-3 col-12 col-md-6 col-xl-4"
        *ngIf="totals.principalAmountX1 !== null"
      >
        <div class="row">
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="">Principal Amount:</span>
          </div>
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="itemCreated">
              {{ totals.principalAmountX1 | number }}
            </span>
          </div>
        </div>
      </div>
      <div
        class="totals-field-4 col-12 col-md-6 col-xl-4"
        *ngIf="totals.principalPaidX1 !== null"
      >
        <div class="row">
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="">Principal Paid:</span>
          </div>
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="itemCreated">
              {{ totals.principalPaidX1 | number }}
            </span>
          </div>
        </div>
      </div>
      <div
        class="col-12 col-md-6 col-xl-4"
        *ngIf="totals.principalRemainingX1 !== null"
      >
        <div class="row">
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="">Principal Remaining:</span>
          </div>
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="itemCreated">
              {{ totals.principalRemainingX1 | number }}
            </span>
          </div>
        </div>
      </div>
      <div
        class="totals-field col-12 col-md-6 col-xl-4"
        *ngIf="totals.principalReversedX1 !== null"
      >
        <div class="row">
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="">Principal Reversed:</span>
          </div>
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="itemCreated">
              {{ totals.principalReversedX1 | number }}
            </span>
          </div>
        </div>
      </div>
      <div
        class="totals-field-1 col-12 col-md-6 col-xl-4"
        *ngIf="totals.principalWrittenOffX1 !== null"
      >
        <div class="row">
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="">Principal WrittenOff:</span>
          </div>
          <div class="col-6 d-flex justify-content-start font-weight-bold">
            <span class="itemCreated">
              {{ totals.principalWrittenOffX1 | number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--card for displaying Completed Loans Report -->
<div
  *ngIf="type === 'Completed Loans' && singleReport"
  [id]="type"
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          Completed Loans Report
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class=""> Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-2 col-xl-1 mx-0 px-2">
                <img
                  class="img-circle-1 mt-2 mt-xl-1 mb-1 pb-0"
                  [src]="itm.customerPhotoUrl"
                  (click)="openModal(template, itm.customerPhotoUrl)"
                />
              </div>
              <div class="col-10 col-xl-11">
                <app-loan-report
                  [itm]="itm"
                  (loanActions)="loanActions($event)"
                  [showActions]="true"
                ></app-loan-report>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="totals-row row mb-3 mx-auto px-auto py-2 border-bottom"
      *ngIf="totals"
    >
      <div class="totals-field col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Paid:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestPaid === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestPaid | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-1 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Remaining:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestRemain === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestRemain | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-2 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Reversed:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestRemain === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestReversed | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-3 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Taken:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestTaken === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestTaken | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-4 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Written Off:</span>
          </div>
          <div
            class="col-6 col-lg-7 col-xl-6 d-flex justify-content-start font-weight-bold text-info mx-0 px-0"
            [hidden]="totals.loanInterestWrittenOff === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestWrittenOff | number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--card for displaying Reversed interest  Report-->
<div
  *ngIf="type === 'Reversed Interest' && singleReport"
  [id]="type"
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          Reversed Interest Report
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class=""> Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-12">
                <app-reversed-interest [itm]="itm"></app-reversed-interest>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="totals-row row mb-3 mx-auto px-auto py-2 border-bottom">
      <div class="col-12 col-md-6">
        <div class="row">
          <div class="col-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Reversed:</span>
          </div>
          <div class="col-6 d-flex justify-content-start font-weight-bold text-info">
            <span class="itemCreated">
              {{ totals.interestReversed | number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--card for displaying Waived Interest Report-->
<div
  *ngIf="type === 'Waived Interest' && singleReport"
  [id]="type"
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          Waived Interest Report
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class=""> Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-12">
                <app-waived-interest [itm]="itm"></app-waived-interest>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="totals-row row mb-3 mx-auto px-auto py-2 border-bottom"
      *ngIf="totals"
    >
      <div class="totals-field col-12 col-md-6">
        <div class="row">
          <div class="col-6 d-flex justify-content-start">
            <span class="font-weight-bold">Loan Amount Taken:</span>
          </div>
          <div
            class="col-6 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.loanAmountTaken === null"
          >
            <span class="itemCreated">
              {{ totals.loanAmountTaken | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="row">
          <div class="col-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Waived Off:</span>
          </div>
          <div
            class="col-6 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.interestWavedOff === null"
          >
            <span class="itemCreated">
              {{ totals.interestWavedOff | number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--card for displaying Waived principal  Report-->
<div
  *ngIf="type === 'Waived Principal' && singleReport"
  [id]="type"
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          Waived Principal Report
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class=""> Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-12">
                <app-waived-principal [itm]="itm"></app-waived-principal>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="totals-row row mb-3 mx-auto px-auto py-2 border-bottom"
      *ngIf="totals"
    >
      <div class="totals-field col-12 col-md-6">
        <div class="row">
          <div class="col-6 d-flex justify-content-start">
            <span class="font-weight-bold">Loan Amount Taken:</span>
          </div>
          <div
            class="col-6 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.loanAmountTaken === null"
          >
            <span class="itemCreated">
              {{ totals.loanAmountTaken | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="row">
          <div class="col-6 d-flex justify-content-start">
            <span class="font-weight-bold">Principal Waived Off:</span>
          </div>
          <div
            class="col-6 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.princimpalWavedOff === null"
          >
            <span class="itemCreated">
              {{ totals.princimpalWavedOff | number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--card for displaying Loan Statement  Report-->
<div
  *ngIf="type === 'Loan Statement' && singleReport"
  [id]="type"
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          Loan Statement Report
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class=""> Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-12">
                <app-loan-payment
                  [itm]="itm"
                  [customer]="microLoanProp.customer"
                ></app-loan-payment>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="totals-row row mb-3 mx-auto px-auto py-2 border-bottom"
      *ngIf="totals"
    >
      <div class="totals-field col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Added:</span>
          </div>
          <div
            class="col-6 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.interestAdded === null"
          >
            <span class="itemCreated">
              {{ totals.interestAdded | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-1 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Paid:</span>
          </div>
          <div
            class="col-6 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.interestPaid === null"
          >
            <span class="itemCreated">
              {{ totals.interestPaid | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-2 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Waived:</span>
          </div>
          <div
            class="col-6 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.interestWaived === null"
          >
            <span class="itemCreated">
              {{ totals.interestWaived | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-3 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Involved:</span>
          </div>
          <div
            class="col-6 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.loanInterestInvolved === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestInvolved | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-4 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Paid:</span>
          </div>
          <div
            class="col-6 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.loanInterestPaid === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestPaid | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Reversed:</span>
          </div>
          <div
            class="col-6 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.loanInterestReversed === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestReversed | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 d-flex justify-content-start">
            <span class="font-weight-bold">Interest Waived:</span>
          </div>
          <div
            class="col-6 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.loanInterestWaived === null"
          >
            <span class="itemCreated">
              {{ totals.loanInterestWaived | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-1 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 d-flex justify-content-start">
            <span class="font-weight-bold">Principal Involved:</span>
          </div>
          <div
            class="col-6 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.principalInvolved === null"
          >
            <span class="itemCreated">
              {{ totals.principalInvolved | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-2 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 d-flex justify-content-start">
            <span class="font-weight-bold">Principal Paid:</span>
          </div>
          <div
            class="col-6 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.principalPaid === null"
          >
            <span class="itemCreated">
              {{ totals.principalPaid | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-3 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 d-flex justify-content-start">
            <span class="font-weight-bold">Principal Waived:</span>
          </div>
          <div
            class="col-6 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.principalWaived === null"
          >
            <span class="itemCreated">
              {{ totals.principalWaived | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="totals-field-4 col-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6 d-flex justify-content-start">
            <span class="font-weight-bold">Balance:</span>
          </div>
          <div
            class="col-6 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.theBalance === null"
          >
            <span class="itemCreated">
              {{ totals.theBalance | number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--card for displaying Interest Accrual  Report-->
<div
  *ngIf="type === 'Interest Accrual' && singleReport"
  [id]="type"
>
  <div class="container mt-3 mb-0 shadow-lg">
    <div class="row">
      <div class="col-12">
        <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
          Interest Accrual Report
        </h4>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 pb-1 mb-0">
    <div class="row mx-auto px-auto mb-2">
      <div class="col-3 d-flex justify-content-start">
        <span class=""> Location: </span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ locationName }}
        </span>
      </div>
    </div>
    <div class="iteration mb-2">
      <div class="item-container my-1">
        <div
          class="pointerCursor list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
          *ngFor="
               let itm of (singleReport | slice: lowValue : highValue)
               let i = index
              "
        >
          <div class="list-card-body card-body my-0 py-0 mx-0">
            <div class="row my-0 py-0">
              <div class="col-12">
                <app-accrual-interest [itm]="itm"></app-accrual-interest>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="totals-row row mb-3 mx-auto px-auto py-2 border-bottom" *ngIf="totals">
      <div class="totals-field col-12 col-md-6">
        <div class="row">
          <div class="col-5 d-flex justify-content-start">
            <span class="font-weight-bold">Loan Amount Taken:</span>
          </div>
          <div class="col-7 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.loanAmountTaken === null">
            <span class="itemCreated">
              {{ totals.loanAmountTaken | number }}
            </span>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="row">
          <div class="col-5 col-md-6 d-flex justify-content-start">
            <span class="font-weight-bold">Principal Waived Off:</span>
          </div>
          <div class="col-7 col-md-6 d-flex justify-content-start font-weight-bold text-info"
            [hidden]="totals.princimpalWavedOff === null">
            <span class="itemCreated">
              {{ totals.princimpalWavedOff | number }}
            </span>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</div>
<div class="row">
  <div class="col-12 mx-0 pt-2">
    <pagination-controls
      (pageChange)="pageChanged($event)"
      (pageBoundsCorrection)="pageChanged($event)"
      maxSize="9"
      directionLinks="true"
      autoHide="true"
      responsive="true"
      previousLabel="Previous"
      nextLabel="Next"
      screenReaderPaginationLabel="Pagination"
      screenReaderPageLabel="page"
      screenReaderCurrentLabel="You're on page"
    >
    </pagination-controls>
  </div>
</div>

<ng-template #template>
  <div class="modal-header bg-info">
    <button
      type="button"
      class="close pull-right"
      aria-label="Close"
      (click)="modalRef.hide()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="col-12 d-flex justify-content-center">
      <pinch-zoom>
        <img
          class="modal-img mx-auto mt-3 mt-md-2 mb-1 pb-0"
          [src]="imageUrl"
        />
      </pinch-zoom>
    </div>
  </div>
</ng-template>
<ng-template #dataModal>
  <app-data-modal
    (close)="getClose($event)"
    (result)="getResult($event)"
    [dataKind]="selectionKind"
    [data]="selectionData"
    [title]="modalTitle"
  ></app-data-modal>
</ng-template>
